export default "__VITE_ASSET__ByZv1LPR__"